import { isAdminRole } from "../../config/permissions";

/** Admin and storekeeper may access Sales Data Import Center. */
export function canAccessSalesDataImport(user) {
  if (!user) return false;
  if (isAdminRole(user.role)) return true;
  const role = String(user.role || "").toLowerCase();
  return role === "storekeeper";
}
